import { createContext, useContext } from 'react';

import type { Contributes, Site } from './config';

export type Route = {
  site: Site;
  path: string;
  catchAll?: string;
  route: string;
  redirectTo?: string;
  owner: string;
  xinglet: string;
  parents: Route[];
  config: Contributes;
};

export type RouteMatcher = (url: string) => Route | undefined;

const RouteContext = createContext<React.PropsWithChildren<{ route?: Route }>>(
  {}
);

export const RouteProvider = RouteContext.Provider;

export const Outlet: React.FC = () => {
  const { children } = useContext(RouteContext);

  return children;
};

export const useRoute = (): Route => {
  const { route } = useContext(RouteContext);

  if (!route) {
    throw new Error('Missing RouteProvider and/or route info');
  }

  return route;
};
